import { MaskLine, FadeUp } from "./Reveal";
import Footer from "./Footer";

export default function Closing() {
    return (
        <section id="new-business" data-testid="closing-section" className="bg-white text-black">
            <div className="px-5 pb-20 pt-24 md:px-8 md:pb-28 md:pt-36">
                <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] md:text-xs">
                    <FadeUp>
                        <span className="text-mmm-red">004</span> — New Business
                    </FadeUp>
                    <FadeUp className="hidden text-black/50 md:block">
                        Response time: prompt enough
                    </FadeUp>
                </div>

                <h2 className="mt-10 font-display text-[clamp(3.2rem,12vw,12rem)] uppercase leading-[0.84] md:mt-14">
                    <MaskLine delay={0.05}>Get the money.</MaskLine>
                    <MaskLine delay={0.15}>
                        <span className="text-mmm-red">Dolla dolla</span>
                    </MaskLine>
                    <MaskLine delay={0.25}>
                        <span className="text-mmm-red">bill y’all.</span>
                    </MaskLine>
                </h2>

                <FadeUp
                    delay={0.15}
                    className="mt-10 max-w-2xl text-base leading-relaxed text-black/60 md:mt-16 md:text-lg"
                >
                    <p data-testid="new-business-body">
                        Got a show, campaign, brand, or strange little idea that deserves
                        a bigger life? Tell us what you’re making and where you need
                        help. We’ll tell you what we can bring to it.
                    </p>
                </FadeUp>

                <FadeUp delay={0.2} className="mt-12 md:mt-16">
                    <a
                        data-testid="contact-cta-button"
                        href="mailto:hello@moneymacmedia.com"
                        className="inline-block border-b-[6px] border-black pb-2 font-display text-[clamp(1.8rem,5.5vw,5.5rem)] uppercase leading-none transition-colors duration-300 hover:border-mmm-red hover:text-mmm-red"
                    >
                        Let’s talk business →
                    </a>
                </FadeUp>

                <FadeUp delay={0.25} className="mt-8">
                    <a
                        data-testid="contact-email-link"
                        href="mailto:hello@moneymacmedia.com"
                        className="font-mono text-xs uppercase tracking-[0.2em] text-black/50 underline-offset-4 transition-colors duration-300 hover:text-mmm-red hover:underline md:text-sm"
                    >
                        hello@moneymacmedia.com
                    </a>
                </FadeUp>
            </div>

            <Footer />
        </section>
    );
}
